import React, { Component, Fragment } from "react";
import "./calculadora_metas"
import ResumoMeta from "../ResumoMeta";
import calculadora from "./calculadora_residuais";
import api from "../../../../services/api";
import FormMetasMensais from "../FormMetasMensais";

export default class FormMetasMensaisContainer extends Component {

    constructor(props) {
        super(props);

        this.state = { 
            resumoMeta: {}
        }

    }

    async componentDidMount() {
        let path = window.location.pathname;
        path = path.split("mensais-");
        path = path[path.length-1];
        await this.loadMetas(path);
    }

    loadMetas = async (id) => {
        let metas = await api.get(`/metas/${id}`);
        this.setState({
            resumoMeta: metas.data.metas
        });
    }

    onChange = () => {
        calculadora.calculaTotalMatriculasNovas(this.state.resumoMeta.tipoMatricula);
    }

    isVisibility = (key) => {
        let resumoMeta = this.state.resumoMeta;
        if(resumoMeta && resumoMeta.tipoMatricula === "Residual" && key > 0) return { visibility: "collapse" }
        else return {};
    }

    render() {
        let {metas, meses, unidade, curso} = this.props;
        return (
            <Fragment>
            <div className="content">
                <div className="row">

                    <div className="col-md-12">
                        <div className="card card-user">

                            <div className="card-header">

                                <div className="row">
                                    <div className="col-md-12">
                                        <h3 className="text-uppercase m-2">{unidade}</h3>
                                        <h6 className="text-uppercase m-2">{curso}</h6>
                                        <a href="./"><button className="btn btn-btn-danger btn-round">Voltar</button></a>
                                    </div>
                                </div>

                            </div>

                            <div className="card-body">

                                <div className="row">
                                    
                                    <div className="col-md-12">
                                        <div className="table table-striped table-hover table-borderless table-sm">
                                            <form onSubmit={this.props.onSubmit} id="formMetasMensais">
                                                <FormMetasMensais
                                                    {...this.props}
                                                    isVisibility={this.isVisibility}
                                                    onChange={this.onChange}
                                                    loadMetas={this.loadMetas}
                                                    tipo={this.state.resumoMeta.tipoMatricula}
                                                />
                                            </form>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        {/* <div className="table table-striped table-hover table-sm table-responsive table-borderless"> */}
                                        <div className="table table-striped table-hover table-borderless table-sm">
                                            <ResumoMeta resumoMeta={this.state.resumoMeta} />
                                        </div>
                                    </div>
                                    

                                </div>

                                    {/* <form onSubmit={this.props.onSubmit} id="formMetasMensais"> */}
                                    {/* <div className="row">
                                        
                                        <div className="col-md-6">
                                            <div className="table table-striped table-hover table-borderless table-sm">
                                                <FormMetasMensais 
                                                    {...this.props}
                                                    isVisibility={this.isVisibility}
                                                    onChange={this.onChange}
                                                    loadMetas={this.loadMetas}
                                                
                                                />
                                            </div>
                                        </div>

                                    </div >

                                    <div className="row">
                                        <div className="col-md-12 m-2">
                                            <button type="submit" className="btn btn-primary btn-round">Cadastrar</button>
                                        </div>
                                    </div> */}

                                    {/* </form>  */}

                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            </Fragment>
        )
    }
}